import { Text } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export function FontFamily()
{
	return (
		<StyleFieldsRow>
			<FontFamilyFields />
		</StyleFieldsRow>
	);
}


/* The family on its own, for a caller that names the location itself - see ruleProperties(). The
   value is a raw css font-family list, eg '"Bodoni Moda", serif'. */
export function FontFamilyFields()
{
	return (
		<LabelOnLeftWrap label='' narrow={true}>
			<Text field='family' />
		</LabelOnLeftWrap>
	);
}
